module.exports = __webpack_public_path__ + "img/02_Filter-1.7d3ed13c.png";